import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

const Header = ({
  productBrand,
  productTitle,
  productDescription,
  productImage,
  productKey,
  isKit,
}) => {
  const title = productBrand ? `${productBrand}, ${productTitle}` : `${productTitle}`;
  const defaultMetaDescription =
    'Zola, the wedding company that’ll do anything for love, is reinventing the wedding planning and registry experience with a free suite of planning tools.';
  // regex used to strip the html tags that are included in the description from the API
  const metaDescription =
    (productDescription && productDescription.replace(/(<.*?>)/g, '')) || defaultMetaDescription;
  const metaLink = isKit
    ? `${window.location.origin}/shop/kit/${productKey}`
    : `${window.location.origin}/shop/product/${productKey}`;
  // NOTE: temporarily fix to check whether the product image url has the https protocol and if not then to append it
  const metaImageUrl = productImage[0] === 'h' ? productImage : `https:${productImage}`;
  return (
    <Helmet defaultTitle={`${title} | Zola`}>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={metaLink} />
      <meta name="twitter:title" property="twitter:title" content={title} />
      <meta name="twitter:image" property="twitter:image" content={metaImageUrl} />
      <meta name="twitter:site" property="twitter:site" content="@zola" />
      <meta name="twitter:description" property="twitter:description" content={metaDescription} />
      <meta name="og:type" property="og:type" content="product" />
      <meta name="og:title" property="og:title" content={title} />
      <meta name="og:description" property="og:description" content={metaDescription} />
      <meta name="og:image" property="og:image" content={metaImageUrl} />
      <meta name="og:site_name" property="og:site_name" content="Zola" />
      <meta name="og:url" property="og:url" content={metaLink} />
    </Helmet>
  );
};

Header.propTypes = {
  productTitle: PropTypes.string,
  productBrand: PropTypes.string,
  productDescription: PropTypes.string,
  productImage: PropTypes.string,
  productKey: PropTypes.string,
  isKit: PropTypes.bool,
};

export default Header;
